import React, { useState, useEffect } from 'react';
import UserCard  from './UserCard.mjs';
import UserLists from './UserLists.mjs';
import UserCreateTeamCard from './UserCreateTeamCard.mjs';
import UserMembershipCard from './UserMembershipCard.mjs';
import UserHistoryCard from './UserHistoryCard.mjs';
import UserSettingsCard from './UserSettingsCard.mjs';
import UserInformation from './UserInformation.mjs';
import { useCTAL } from './CTAL_Hooks.js';

const DEBUG = 0;

export default function UserColumn() 
{
    const { app_user,  user_display_refresh, setUserDisplayRefresh } = useCTAL();

    const [display_type, setDisplayType] = useState("user-lists"); 
    const [display, setDisplay] = useState( <> <UserLists app_user={app_user}/> </> );

    useEffect(() =>
    {
        if (app_user) show_display(display_type, true); //Need to reset team and user_id on Context value change
        if (DEBUG) console.log(`UserColumn** - UserFullName from Context: ${app_user.UserFullName}, setUserDisplayRefresh: false`);
        setUserDisplayRefresh(false); //User is reloaded on setUserDisplayRefresh(true);
    }, [ app_user ]);

    if (!app_user) return;

    const show_display = (d_type, reset=false) => { 

        if ((display_type == d_type) && (!reset))
            return;

        switch (d_type)
        {
            case "user-lists":
            default:
                setDisplay( <> <UserLists app_user={app_user}/> </> ); 
                break;
            case "create-team":
                setDisplay( <> <UserCreateTeamCard show_display={show_display}/> </> ); 
                break;
            case "request-join-team":
                setDisplay( <> <UserMembershipCard app_user={app_user} /> </> ); 
                break;
            case "team_invitations":
                setDisplay( <> <UserMembershipCard app_user={app_user} show_invitations={true} /> </> ); 
                break;
            case "user-history":
                setDisplay( <> <UserHistoryCard user_id={app_user.UserID} /> </> ); 
                break;
            case "user-settings":
                setDisplay( <> <UserSettingsCard app_user={app_user} /> </> ); 
                break;
            case "user-information":
                setDisplay( <> <UserInformation /> </> ); 
                break;

        }

        setDisplayType(d_type);
    }
   
    if (DEBUG) { console.log(`UserColumn - ${app_user.UserID}, display_type: ${display_type}`); return; }

    return (
        <>
            <UserCard app_user={app_user} show_display={show_display} /> 
            <div>{display}</div>          
        </>
    );
}